export const STORE_LOCATOR_BUILDER_COMPONENT_NAME = "StoreLocator";
